import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index'
import Quest from '@/pages/quest'
import Desc from '@/pages/desc'
import Form from '@/pages/form'
import Complaint from '@/pages/complaint'
import ComSuccess from '@/pages/comSuccess'
import Service from '@/pages/service'



Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'index',
    component: Index,
    meta: {
      title: '刷机帮助'
    }
  },
  {
    path: '/index',
    name: 'index',
    component: Index,
    meta: {
      title: '刷机帮助'
    }
  },
  {
    path: '/service',
    name: 'service',
    component: Service,
    meta: {
      title: '人工服务'
    }
  },

  {
    path: '/quest/:id',
    name: 'quest',
    component: Quest,
    meta: {
      title: '刷机帮助'
    }
  }, {
    path: '/desc/:id',
    name: 'Desc',
    component: Desc,
    meta: {
      title: '刷机帮助'
    }
  },
  {
    path: '/form',
    name: 'Form',
    component: Form,
    meta: {
      title: '刷机帮助'
    }
  },
  {
    path: '/complaint',
    name: 'Complaint',
    component: Complaint,
    meta: {
      title: '官方投诉中心'
    }
  },
  {
    path: '/comSuccess',
    name: 'comSuccess',
    component: ComSuccess,
    meta: {
      title: '官方投诉中心'
    }
  }




  ]
})

// 全局路由钩子函数 对全局有效
router.beforeEach((to, from, next) => {

  if (to.meta.title) {
    document.title = to.meta.title
  }
  next();
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js